import React, { Component } from "react";
import { connect } from "react-redux";

import { postServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { CAMPAIGN_DATA_OF_USER } from "../../../action/salesUser_action_types";

import Header from "../common/AuthHeader";
import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import { history } from "../../../history/history";
import Pagination from "../../common/Pagination";
import { axiosInstnace, getLocalData } from "../../../util/util";
import { endPoints } from "../../../config";
import moment from "moment";

class CampaignListComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      salesUserInfo: getLocalData("salesUserInfo"),
      page: 1,
      limit: 10,
      selectedCampaigns: [],
      currentpayouts: true,
      totalRecords: 0,
      campaigndetails: [],
      campaignsData: [],
      silver: {},
      gold: {},
      targetAmountAcheieved: 0,
      totalCamp: 0,
      grade: 0,
      openedWindowRef: undefined
    };
  }

  //Get Campaign Data
  componentDidMount = async () => {
    let { page } = this.state;
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      //   page
    };
    let data1 = await axiosInstnace.post(
      endPoints.getcampaignsbasedondsa,
      data
    );
    let {
      grade,
      targetAmountAcheieved,
      silver,
      gold,
      totalCamp,
    } = data1.data.data;
    this.setState({
      silver,
      gold,
      targetAmountAcheieved,
      totalCamp,
      grade,
    });
    this.getCampignsData(page);
  };

  selectCampaigns = (e, id) => {
    let { selectedCampaigns } = this.state;
    if (e.currentTarget.checked) {
      selectedCampaigns.push(id);
    } else {
      selectedCampaigns = selectedCampaigns.filter((el) => {
        el !== id;
      });
    }
    this.setState({
      selectedCampaigns,
    });
  };

  //Fetching Campign Data from backend
  getCampignsData = async (page) => {
    let { salesUserInfo, currentpayouts } = this.state;
    let status = currentpayouts ? "generated,Paid" : "Received";
    let data = {
      email: salesUserInfo.email,
      status,
    };
    let result = await axiosInstnace.get(endPoints.getInvoices, {
      params: data,
    });
    this.setState({
      campaignsData: result.data.data,
    });
  };

  //Go to Route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };
  viewpastpayouts = async () => {
    await this.setState({
      currentpayouts: !this.state.currentpayouts,
    });
    this.getCampignsData();
  };

  acceptpayment = async () => {
    let params = {
      invoices: this.state.selectedCampaigns,
      status: "Received",
    };
    let result = await axiosInstnace.post(endPoints.updateinvoice, params);
    window.location.reload(true);
  };

  signInvoice = async (invoiceID) => {
    let localOpenedWindowRef = undefined;

    window.onmessage = function(e) {
      if(e.data == 'success'){
        localOpenedWindowRef.close();
        window.location.reload();
      }
    }
    
    let params = { invoiceID};
    let signInvoice = await axiosInstnace.post(endPoints.signinvoice, params);

    if(signInvoice.data.signurllink){
      localOpenedWindowRef = window.open(signInvoice.data.signurllink, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=800');
    }
  };
  
  render() {
    let { campaignsData, totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
            <Header
              silver={this.state.silver}
              gold={this.state.gold}
              targetAmountAcheieved={this.state.targetAmountAcheieved}
              totalCamp={this.state.totalCamp}
              grade={this.state.grade}
            />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                {campaignsData && campaignsData.length > 0 ? (
                  <div className={`camp_wrapper`}>
                    <div className="running_cap_head">
                      <h2 className="camp_head">Payout Details</h2>
                      <div className="camp_right">
                        <div className="create_camp_btn">
                          {this.state.selectedCampaigns.length > 0 && (
                            <button onClick={this.acceptpayment}>
                              Payment Received
                            </button>
                          )}{" "}
                          {this.state.currentpayouts && (
                            <button onClick={this.viewpastpayouts}>
                              View Past Payouts
                            </button>
                          )}{" "}
                          {!this.state.currentpayouts && (
                            <button onClick={this.viewpastpayouts}>
                              View Pending Payouts
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="camp_listing_wrapper">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>
                              Select
                            </th>
                            <th>Invoice Number</th>
                            <th>Invoice Date</th>
                            <th>Payment Date</th>
                            <th>Invoice Amount</th>
                            <th>TDS Deduction</th>
                            <th>Other Deduction</th>
                            <th>
                              Total{" "}
                              <img
                                src="../../assets/images/rupee-indian.svg"
                                className="camp_rupee"
                              />
                            </th>
                            <th>Remarks</th>
                            <th>Invoice Signed</th>
                            <th>Invoice Copy</th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaignsData.map((campaign, index) => {
                            indexNum++;
                            return (
                              <tr key={index}>
                                <td>
                                  {campaign.status === "Paid" && (
                                    <input
                                      type="checkbox"
                                      onClick={(e) => {
                                        this.selectCampaigns(
                                          e,
                                          campaign.invoiceno
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                <td>{campaign.invoiceno}</td>
                                <td>
                                  {moment(campaign.date).format("DD MMM YYYY")}
                                </td>
                                <td>
                                  {campaign.transaction &&
                                    moment(campaign.transaction.date).format(
                                      "DD MMM YYYY"
                                    )}
                                </td>
                                <td>{campaign.totalamount}</td>
                                <td>
                                  {campaign.transaction &&
                                    campaign.transaction.tdsamount}
                                </td>
                                <td>
                                  {campaign.transaction &&
                                    campaign.transaction.otherdeduction}
                                </td>
                                <td>
                                  {campaign.transaction &&
                                    campaign.transaction.amount}
                                </td>
                                <td>
                                  {campaign.transaction &&
                                    campaign.transaction.remarks}
                                </td>
                                <td>
                                  { campaign.invoicesigned ? (
                                    <p style={{textAlign: "center"}}>Yes</p>
                                  ):(
                                    <div>
                                      <p style={{textAlign: "center"}}>No</p>
                                       
                                      <button onClick={ (e) => { this.signInvoice(campaign.invoiceno) }} style={{borderRadius: "5px", padding: "10px", color: "white", background: "#085dab", border: "0px"}}>Sign Invoice now</button>
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <a target="_blank" href={campaign.document}>
                                    Download
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="paginationTable">
                        {totalRecords >= 10 && (
                          <Pagination
                            getAllData={this.getCampignsData}
                            totalRecords={totalRecords}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`bookcampaign`}>
                    <div>
                      <img src="../../assets/images/radio.png" />
                    </div>

                    <div className="book_camp_para">
                      {this.state.currentpayouts && (
                        <p>
                          It seems like you don't have any Pending payout's yet
                        </p>
                      )}
                      {!this.state.currentpayouts && (
                        <p>
                          It seems like you don't have any Past payout's yet
                        </p>
                      )}
                    </div>
                    <div className="book_camp_btn">
                      {this.state.currentpayouts && (
                        <button onClick={this.viewpastpayouts}>
                          View Past Payouts
                        </button>
                      )}{" "}
                      {!this.state.currentpayouts && (
                        <button onClick={this.viewpastpayouts}>
                          View Pending Payouts
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaignsData: state.sales.get("campaignsDataOfUser"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUserCampaign: (url, data, type) =>
      dispatch(postServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CampaignListComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/payoutdetails.jsx